import { translationLivechat_da_part1 } from "./translationLivechat.da.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationLivechat_da_part2 } from "./translationLivechat.da.part2";
import { translationLivechat_da_part3 } from "./translationLivechat.da.part3";
import { translationLivechat_da_availability } from "./translationLivechat.da.availability";
import { translationLivechat_da_autoClose } from "./translationLivechat.da.autoClose";
import { translationLivechat_da_header } from "./translationLivechat.da.header";
import { translationLivechat_da_schedules } from "./translationLivechat.da.schedules";

export const translationLivechat_da = defineTranslationTree({
  ...translationLivechat_da_availability,
  ...translationLivechat_da_autoClose,
  ...translationLivechat_da_header,
  ...translationLivechat_da_schedules,
  ...translationLivechat_da_part1,
  ...translationLivechat_da_part2,
  ...translationLivechat_da_part3,
});
